module.exports = __webpack_public_path__ + "img/sc.592a44a1.svg";